import { Box, Skeleton } from '@mui/material';

export const LoadingSkeletonPage2 = ({ infos }) => {
    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            {/* Sidebar Skeleton */}
            <Box
                sx={{
                    width: '270px',
                    padding: '8px 12px',
                    backgroundColor: '#fff',
                    borderRight: '1px solid #eaecef',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Logo Skeleton */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                    <Skeleton variant="rectangular" width={127} height={55} />
                </Box>
                <Skeleton variant="rectangular" width="100%" height={1} sx={{ mb: 2 }} />

                {/* Menu Items Skeleton */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px', pt: 2 }}>
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <Skeleton key={item} variant="rectangular" width="100%" height={45} sx={{ borderRadius: '8px' }} />
                    ))}
                </Box>

                {/* Back Button Skeleton */}
                <Skeleton variant="rectangular" width="100%" height={1} sx={{ mb: 2 }} />
                <Skeleton variant="rectangular" width="100%" height={45} sx={{ borderRadius: '8px', mb: 1 }} />
            </Box>

            {/* Main Content Skeleton */}
            <Box sx={{ backgroundColor: infos?.primary_color, flex: 1, display: 'flex', flexDirection: 'column', opacity: 0.5, zIndex: 0 }}>
                {/* Banner Skeleton */}
                <Box sx={{ padding: '40px 50px 20px 40px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Skeleton variant="text" width={400} height={50} sx={{ bgcolor: 'rgba(255,255,255,0.7)' }} />
                    <Skeleton variant="text" width={300} height={40} sx={{ bgcolor: 'rgba(255,255,255,0.7)', mb: 1 }} />
                </Box>

                <Box sx={{ padding: '0 50px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Skeleton variant="text" width="80%" height={25} sx={{ bgcolor: 'rgba(255,255,255,0.65)' }} />
                    <Skeleton variant="text" width="75%" height={25} sx={{ bgcolor: 'rgba(255,255,255,0.65)' }} />
                    <Skeleton variant="text" width="70%" height={25} sx={{ bgcolor: 'rgba(255,255,255,0.65)' }} />
                </Box>

                {/* Cards Grid Skeleton */}
                <Box sx={{ padding: '40px 50px', flex: 1 }}>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '20px',
                        maxWidth: '1200px'
                    }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map((card) => (
                            <Skeleton
                                key={card}
                                variant="rectangular"
                                width="100%"
                                height={240}
                                sx={{ borderRadius: '12px', bgcolor: 'rgba(255,255,255,0.65)' }}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        </div>
    );
};